import { BaseDropdown, BaseInput, Ptag } from "components/core";
import React, { useMemo, useState } from "react";
import "./styles.css";
import GradeAccordion from "./GradeAccordion";
import { colors } from "theme";

const FORMIK_CO = [
  "esc_limit",
  "esc_limit_min",
  "esc_limit_max",
  "parent_limit",
  "parent_limit_min",
  "parent_limit_max"
];

const GradeCoPayment = ({
  formikProps,
  attribute,
  toggleHandler,
  selectedDependents,
}) => {
  const doesValueExist = useMemo(() => {
    const values = formikProps.values;
    return FORMIK_CO.some(key => values[key]);
  }, [formikProps]);

  let selectedDetails = localStorage.getItem("eb_selected_values");
  if (selectedDetails) {
    selectedDetails = JSON.parse(selectedDetails);
  }

  const isFlex = useMemo(() => {
    return selectedDetails?.flex;
  }, [selectedDetails]);

  const initalToggleStatus = useMemo(() => {
    let status = false;
    if (!attribute?.toggle) {
      status = true;
    }
    if (doesValueExist) {
      status = true;
    }
    return status;
  }, [attribute, doesValueExist]);

  const [toggleStatus, setToggleStatus] = useState(initalToggleStatus);
  const showRangeForEsc = useMemo(() => {
    const selectables = attribute?.selectable_values;
    if (
      selectables?.length &&
      selectables[0]["For Employee, Spouse and Children"]?.length
    )
      return true;
    return false;
  }, [attribute]);
  const showRangeForParents = useMemo(() => {
    const selectables = attribute?.selectable_values;
    if (selectables?.length && selectables[0]["For Parents/In-laws"]?.length)
      return true;
    return false;
  }, [attribute]);

  const escOptions = useMemo(() => {
    const selectables = attribute?.selectable_values;

    if (selectables.length === 0) return [];
    return selectables?.[0]?.["For Employee, Spouse and Children"]?.map(
      (val) => ({
        label: val,
        value: val,
      })
    );
  }, [attribute]);

  const parentsOptions = useMemo(() => {
    const selectables = attribute?.selectable_values;

    if (selectables.length === 0) return [];
    return selectables?.[0]?.["For Parents/In-laws"]?.map((val) => ({
      label: val,
      value: val,
    }));
  }, [attribute]);

  const interstitialToggler = (bool) => {
    setToggleStatus(bool);
    if(!bool) {
      FORMIK_CO.forEach(key => {
        formikProps.setFieldValue(key, "", true);
      });
    }
    toggleHandler &&
      toggleHandler(bool, attribute?.attribute_data?.attribute_name);
  };

  const showParentInLaws = useMemo(() => {
    if (!selectedDependents) return false;
    return (
      selectedDependents.includes("Parents") ||
      selectedDependents.includes("In-laws")
    );
  }, [selectedDependents]);

  // Input validation handlers - allow all characters
  const handleKeyPress = (e) => {
    // Allow all characters - no restrictions
    return;
  };

  const handlePaste = (e) => {
    // Allow all characters - no restrictions
    return;
  };

  const handleInput = (e) => {
    // Allow all characters - no restrictions
    return;
  };

  return attribute ? (
    <GradeAccordion
      title={"Co-payment"}
      showSwitch={attribute?.toggle}
      canSelect={toggleStatus}
      setToggleStatus={interstitialToggler}
    expanded={toggleStatus}
    >
      <div>
        <div className="sum-insured-container">
          {showRangeForEsc ? (
            <BaseDropdown
              staticLabel="For Employee, Spouse and Children"
              fontSize="16px !important"
              disabled={!toggleStatus}
              options={escOptions}
              formikProps={{ ...formikProps, name: "esc_limit" }}
            />
          ) : (
            <BaseInput
              staticLabel="For Employee, Spouse and Children"
              disabled={!toggleStatus}
              fontSize="16px !important"
              type="text"
             
              formikProps={{ ...formikProps, name: "esc_limit" }}
              onKeyDown={handleKeyPress}
              onPaste={handlePaste}
              onInput={handleInput}
            />
          )}
          {/* Error display for esc_limit */}
         
        
          {showRangeForEsc && isFlex && (
            <div>
              <Ptag
                color={colors.primaryColor}
                fontSize="14px"
                marginBottom="10px"
              >
                Range
              </Ptag>
              <div className="sum-insured-container">
                <BaseDropdown
                  fontSize="16"
                  label="Min"
                  disabled={!toggleStatus}
                  options={escOptions}
                  formikProps={{ ...formikProps, name: "esc_limit_min" }}
                />
                <BaseDropdown
                  fontSize="16"
                  disabled={!toggleStatus}
                  label="Max"
                  options={escOptions}
                  formikProps={{ ...formikProps, name: "esc_limit_max" }}
                />
              </div>
            </div>
          )}
        </div>
        {showParentInLaws && (
          <div
            className="sum-insured-container"
            style={{
              marginTop: "2rem",
            }}
          >
            {showRangeForParents ? (
              <BaseDropdown
                staticLabel="For Parents/ In-laws"
                fontSize="16"
                disabled={!toggleStatus}
                options={parentsOptions}
                formikProps={{ ...formikProps, name: "parent_limit" }}
              />
            ) : (
              <BaseInput
                staticLabel="For Parents/ In-laws"
                disabled={!toggleStatus}
                type="text"
                fontSize="16px !important"
         
                formikProps={{ ...formikProps, name: "parent_limit" }}
                onKeyDown={handleKeyPress}
                onPaste={handlePaste}
                onInput={handleInput}
              />
            )}
          {/* Error display for parent_limit */}
          
           
            {showRangeForParents && isFlex && (
              <div>
                <Ptag
                  color={colors.primaryColor}
                  fontSize="14px"
                  marginBottom="10px"
                >
                  Range
                </Ptag>
                <div className="sum-insured-container">
                  <BaseDropdown
                    fontSize="16"
                    label="Min"
                    disabled={!toggleStatus}
                    options={parentsOptions}
                    formikProps={{ ...formikProps, name: "parent_limit_min" }}
                  />
                  <BaseDropdown
                    fontSize="16"
                    label="Max"
                    disabled={!toggleStatus}
                    options={parentsOptions}
                    formikProps={{ ...formikProps, name: "parent_limit_max" }}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </GradeAccordion>
  ) : null;
};

export default GradeCoPayment;
